<template>
	<a class="button" :class="[color, { compact }]" data-zc-action="open">
		<slot />
	</a>
</template>

<script setup>
defineProps({
	color: { type: String, default: 'light' },
	compact: { type: Boolean, default: false },
});
</script>

<style lang="scss" scoped>
button {
	cursor: pointer;

	&:hover {
		text-decoration: none;
	}
}

.reserve-now {
	border: 2px solid #fff;
	background: none;
	padding: 14px 32px;
	margin: 0;
	color: #fff;
	transition: all 0.3s ease-in-out;

	&:hover {
		background: #fff;
		color: var(--cta-color-hover);
	}

	&.dark {
		border-color: 2px solid var(--cta-color-hover);
		color: var(--cta-color-hover);

		&:hover {
			color: var(--nav-color-light);
			background: var(--cta-color-hover);
			border-color: var(--cta-color-hover);
		}
	}

	&.medium {
		border: 2px solid var(--nav-color-dark);
		color: var(--nav-color-dark);

		&:hover {
			background: var(--nav-color-dark);
			color: var(--cta-color-hover);
		}
	}

	&.compact {
		border-left: none;
		border-right: none;
		border-top: none;
		border-bottom-color: #000;
		padding: 1px 0;
		position: relative;

		&:hover {
			background: none;
			color: var(--cta-color-hover);
			border-color: var(--button-nofill-hover);
		}
	}
}

@media (max-width: 920px) {
	.reserve-now {
		z-index: 2;
	}

	.reserve-now,
	.reserve-now.medium {
		padding: 5px 10px;
	}
}
</style>
